<wm-common-confirmation-modal
  [data]="modalData"
  (click)="close()"
  [isApplicantMobileview]="true"
>
  <div class="dialog-container">
    <div class="options">
      <!-- Start from blank -->
      <div class="option-card">
        <div class="bold-text">
          <wm-common-text
            [data]="{ text: 'Start from blank' }"
          ></wm-common-text>
        </div>

        <div class="normal-text">
          <wm-common-text
            [data]="{
              text: 'This will create a new blank workflow with just a start activity.'
            }"
          ></wm-common-text>
        </div>

        <div class="blank-btn-margin">
          <wm-common-button
            [data]="{
              text: 'CREATE BLANK',
              onClick: openBlank.bind(this)
            }"
          ></wm-common-button>
        </div>
      </div>

      <!-- Start from template -->
      <div class="option-card">
        <div class="bold-text">
          <wm-common-text
            [data]="{ text: 'Start from a template' }"
          ></wm-common-text>
        </div>

        <div class="normal-text">
          <wm-common-text
            [data]="{
              text: 'This will allow you select a workflow from our template library to use as a starting point.'
            }"
          ></wm-common-text>
        </div>

        <div class="template-btn-margin">
          <wm-common-button
            [data]="{
              text: 'USE TEMPLATE',
              onClick: openTemplate.bind(this)
            }"
          ></wm-common-button>
        </div>
      </div>
    </div>
  </div>
</wm-common-confirmation-modal>